// MyMap.jsx or similar
import {
  Map as Gogel,
  AdvancedMarker,
  useMapsLibrary,
  useAdvancedMarkerRef,
  InfoWindow,
} from '@vis.gl/react-google-maps';
import { Location } from '../../Clients/reminds';
import { useCallback, useState } from 'react';

import styles from './Map.module.css';

type MapProps = {
  locations: Location[];
};
const Map = ({ locations }: MapProps) => {
  useMapsLibrary('places');
  const handleMarkerSelected = useCallback((placeId: string) => {
    console.log(placeId);
  }, []);
  if (!locations || locations.length == 0) {
    return null;
  }
  const defaults = calculateCenterAndBounds(locations);
  return (
    <Gogel
      id={'map'}
      renderingType={'VECTOR'}
      mapId={'ad4f1e98081f9351325bf235'}
      style={{ width: '100%', height: '500px' }}
      defaultCenter={{ lat: defaults.lat, lng: defaults.lng }}
      gestureHandling={'greedy'}
      defaultZoom={10}
      disableDefaultUI={true}
      defaultBounds={{
        east: defaults.east,
        west: defaults.west,
        north: defaults.north,
        south: defaults.south,
      }}
    >
      {locations.map(location => {
        return (
          <MarkerWithInfoWindow
            placeId={location.placeId}
            key={location.id}
            onMarkerSelected={handleMarkerSelected}
            position={{
              lat: location.latitude as number,
              lng: location.longitude as number,
            }}
          />
        );
      })}
    </Gogel>
  );
};

type MarkerWithInfoWindowProps = {
  position: google.maps.LatLng | google.maps.LatLngLiteral | null;
  placeId: string | undefined;
  onMarkerSelected: (placeId: string) => void;
};
const MarkerWithInfoWindow = ({ position, placeId }: MarkerWithInfoWindowProps) => {
  const [markerRef, marker] = useAdvancedMarkerRef();
  const [infoWindowShown, setInfoWindowShown] = useState(false);
  const [place, setPlace] = useState<google.maps.places.Place | null>(null);

  const handleMarkerClick = useCallback(async () => {
    if (!placeId) {
      return;
    }
    const place = new google.maps.places.Place({ id: placeId });
    // await place.fetchFields({ fields: ['displayName'] });
    setPlace(place);

    setInfoWindowShown(isShown => !isShown);
  }, [placeId]);

  const handleClose = useCallback(() => setInfoWindowShown(false), []);

  return (
    <>
      <AdvancedMarker ref={markerRef} position={position} onClick={handleMarkerClick} className={styles.marker} />

      {infoWindowShown && place && (
        <InfoWindow anchor={marker} onClose={handleClose}>
          <p>{place.id}</p>
        </InfoWindow>
      )}
    </>
  );
};

export default Map;

function calculateCenterAndBounds(locations: Location[]) {
  const result = locations.reduce(
    (acc, { latitude = 0, longitude = 0 }) => {
      acc.sumLat += latitude;
      acc.sumLng += longitude;

      acc.south = Math.min(acc.south, latitude);
      acc.north = Math.max(acc.north, latitude);
      acc.east = Math.max(acc.east, longitude);
      acc.west = Math.min(acc.west, longitude);

      return acc;
    },
    {
      sumLat: 0,
      sumLng: 0,
      south: Infinity,
      north: -Infinity,
      east: -Infinity,
      west: Infinity,
    },
  );

  const count = locations.length;
  return {
    lat: result.sumLat / count,
    lng: result.sumLng / count,
    south: result.south,
    north: result.north,
    east: result.east,
    west: result.west,
  };
}
